import { render, staticRenderFns } from "./Terminvorlage.vue?vue&type=template&id=3e04b2b4"
import script from "./Terminvorlage.vue?vue&type=script&lang=js"
export * from "./Terminvorlage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports